<div class="container-fluid">
  <form #invForm="ngForm">
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>Received Inventory Search</h3>
      </div>
    </div>

    <hr style="margin-top: 2px; margin-bottom: 2px" />

    <div class="row top11">
      <aims-form [cols]="2" [spaceRows]="true">
        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field appearance="fill">
            <mat-select #aimsControl="ngModel" name="Group" [(ngModel)]="searchCriteria.inventoryGroupId">
              <mat-option *ngFor="let ig of inventoryGroups | async" [value]="ig.inventoryGroupId">
                {{ ig.inventoryGroupCode }} - {{ig.inventoryGroup}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field appearance="fill">
            <input
              matInput
              type="text"
              #aimsControl="ngModel"
              name="Inventory Item #"
              id="inventoryItemBarcode"
              [(ngModel)]="searchCriteria.barcode"
            />
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <input
              name="Start Date"
              matInput
              #aimsControl="ngModel"
              [matDatepicker]="picker1"
              [(ngModel)]="searchCriteria.startDate"
            />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="3">
          <mat-form-field appearance="fill">
            <mat-label></mat-label>
            <input name="End Date" matInput #aimsControl="ngModel" [matDatepicker]="picker2" [(ngModel)]="searchCriteria.endDate" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </aims-fc>

        <aims-fc [labelColSize]="2" [controlColSize]="2">
          <mat-form-field appearance="fill">
            <mat-select #aimsControl="ngModel" name="Owner" [(ngModel)]="searchCriteria.ownerId" >
                <mat-option *ngFor="let o of owners | async" [value]="o.equipmentOwnerId">
                  {{ o.equipmentOwner }}
                </mat-option>
            </mat-select>
          </mat-form-field>
        </aims-fc>

      </aims-form>

      <hr style="margin-top: 2px; margin-bottom: 2px" />

      <aims-form [cols]="1" [spaceRows]="true">
        <div class="col-xs-12 text-center">
          <aims-common-button title="Clear Criteria" aria-label="Clear" (click)="clearForm()">
            <mat-icon color="primary">clear</mat-icon>
            Clear
          </aims-common-button>

          <aims-common-button
            title="Search"
            aria-label="Search"
            [disabled]="!(invForm.form.valid)"
            (click)="search()"
          >
            <mat-icon color="primary">search</mat-icon>
            Search
          </aims-common-button>
        </div>
      </aims-form>
    </div>
  </form>

  <aims-common-table
    id="received-inventory-search-table"
    [dataSource]="receivedItems"
    [header]="header"
    [permissions]="tablePermissions"
    label="Received Inventory"
    pageSize="20"
    [exportFunction]="getDataForExport"
    [stickyHeader]="true">

    <aims-common-table-dynamic-row id="ownerId">
      <ng-template viewMode let-element >
         {{ element.inventoryItem.ownerId| getText:'equipmentOwnerId':'equipmentOwner':owners| async }}
      </ng-template>

      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let o of owners | async" [value]="o.equipmentOwnerId">
              {{ o.equipmentOwner }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="costPerUnit">
      <ng-template viewMode let-element >
         {{ element.costPerUnit | currency }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="total">
      <ng-template viewMode let-element >
         {{ (element.costPerUnit * element.originalQuantity) | currency }}
      </ng-template>
    </aims-common-table-dynamic-row>

    </aims-common-table>

    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner" ></aims-spinner>
</div>
